import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Profissionais = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="PROFISSIONAIS FISIOTERAPEUTAS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Fisioterapeuta" nome="tecfisioteraputa" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="56vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Crefito Nº" nome="crefito" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Dias/Horas de Trabalho" nome="hora" tipo="text" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Responsável Técnico do Serviço" nome="responsavel" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa >
            )
        }
        return partes
    }
}

export default Profissionais